import {
  FindByIdProductCostDto, FindByIdProductCreditDocumentRequirementDto,
  FindByIdProductResponseDto
} from '@features/product/application/use_cases/find-by-id-product/dto/find-by-id-product.response.dto';
import {
  FindByIdProductPayloadDto
} from '@features/product/application/use_cases/find-by-id-product/dto/find-by-id-product.payload.dto';

import {
  FindByIdProductCostHttpDto, FindByIdProductCreditDocumentRequirementHttpDto,
  FindByIdProductHttpDto,
  FindByIdProductHttpResponseDto
} from '@features/product/infrastructure/http/find-by-id-product/find-by-id-product.http.response.dto';
import {
  FindByIdProductHttpPayloadDto
} from '@features/product/infrastructure/http/find-by-id-product/find-by-id-product.http.payload.dto';

export class FindByIdProductHttpMapper {

  static toResponse(data: FindByIdProductHttpResponseDto): FindByIdProductResponseDto | null {
    const item = data.data[0];
    if (!item) return null;
    return this.mapItem(item);
  }

  static toInfra(data: FindByIdProductPayloadDto): FindByIdProductHttpPayloadDto {
    return {}
  }

  static mapItem(item: FindByIdProductHttpDto): FindByIdProductResponseDto {
    return {
      id: item.id,
      agreement_id: item.agreement_id.toString(),
      name: item.name,
      description: item.description,
      type: item.type,
      court_date: item.court_date ? item.court_date.toString() : null,
      amortize_additional_costs: item.amortize_additional_costs == 1,
      min_amount: Number(item.min_amount),
      max_amount: Number(item.max_amount),
      step_amount: Number(item.step_amount),
      min_term: item.min_term,
      max_term: item.max_term,
      step_term: item.step_term,
      step_installment: item.step_installment,
      term_type: item.term_type.toString(),
      rate_amount: Number(item.rate_amount),
      bail_amount: Number(item.bail_amount),
      bail_type: item.bail_type.toString(),
      bail_method: item.bail_method,
      platform_cost: Number(item.platform_cost),
      platform_discount: Number(item.platform_discount),
      late_interest_ea: item.late_interest_ea,
      default: item.default == 1,
      hidden: item.hidden == 1,
      tyc_url: item.tyc_url,
      vat_value: item.vat_value,
      not_validate: item.not_validate == 1,
      document_validate: item.document_validate == 1,
      biometric_2d_validate: item.biometric_2d_validate == 1,
      biometric_3d_validate: item.biometric_3d_validate == 1,
      validation_cost: item.validation_cost,
      requirement_fields: item.requirement_fields,
      is_multicredit: item.is_multicredit == 1,
      is_rechargeable: item.is_rechargeable == 1,
      is_withdrawable: item.is_withdrawable == 1,
      is_manual_disbursement: item.is_manual_disbursement == 1,
      credit_study: item.credit_study == 1,
      credit_study_value: item.credit_study_value,
      signature_template_id: item.signature_template_id,
      scoring_id: item.scoring_id,
      amortize_bail: false,
      other_costs: item.other_costs.map(this.mapCost),
      discounts: item.discounts.map(this.mapCost),
      insurance: item.insurance.map(this.mapCost),
      taxes_cost: item.taxes_cost.map(this.mapCost),
      untaxed_cost: item.untaxed_cost.map(this.mapCost),
      credit_document_requirements: item.credit_document_requirements ? item.credit_document_requirements.map(this.mapDocumentType) : []
    }
  }

  static mapCost(item: FindByIdProductCostHttpDto): FindByIdProductCostDto {
    return {
      id: item.id.toString(),
      product_id: item.product_id,
      type: Number(item.type),
      value: Number(item.value),
      description: item.description,
      is_taxable: item.is_taxable,
    };
  }

  static mapDocumentType(item: FindByIdProductCreditDocumentRequirementHttpDto): FindByIdProductCreditDocumentRequirementDto {
    return {
      id: item.credit_document_type.id,
      type: "existing",
      credit_document_type_id: item.credit_document_type.id,
      description: item.description,
      is_required: item.is_required,
      name: item.credit_document_type.name,
      code: item.credit_document_type.code,
      product_id: item.product_id,
      order: item.order
    }
  }

}
